import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ChloromanceMobileApp from './mobile/Chloromance/MobileApp';
import WheelOfChoresMobileApp from './mobile/WheelOfChores/MobileApp';
import reportWebVitals from './reportWebVitals';

const mobileApps = {
  chloromance: ChloromanceMobileApp,
  'wheel-of-chores': WheelOfChoresMobileApp,
};

const buildTarget = process.env.REACT_APP_BUILD_TARGET as keyof typeof mobileApps | undefined;
const RootApp = buildTarget ? mobileApps[buildTarget] ?? App : App;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
